import { handleActions } from "redux-actions";
import { COLLECTIONS } from "constants/action-types";
import { List, Map } from "immutable";

export interface IRollupObjectState {
    fetchingObjects: boolean;
    objects: { [key: string]: List<Map<string, any>> };
}

const initialState: IRollupObjectState = {
    fetchingObjects: false,
    objects: undefined,
};

export const collectionRollupObjects = handleActions<IRollupObjectState>(
    {
        [COLLECTIONS.COLLECTION.ROLLUP_OBJECT.FETCH.START]: (state: IRollupObjectState): IRollupObjectState => {
            return {
                ...state,
                fetchingObjects: true,
            };
        },
        [COLLECTIONS.COLLECTION.ROLLUP_OBJECT.FETCH.COMPLETED]: (
            state: IRollupObjectState,
            { payload, error }: any,
        ): IRollupObjectState => {
            if (error) {
                return {
                    ...state,
                    fetchingObjects: false,
                };
            } else {
                return {
                    ...state,
                    fetchingObjects: false,
                    objects: payload,
                };
            }
        },
    },
    initialState,
);
